import type { PlacementDataSource } from '~/api/data-source/placement';
import { placementDataSource } from '~/api/data-source/placement';
import type { PlacementNavigationBar } from '~/api/model';
import { parseModelArray, placementNavigationBarSchema } from '~/api/model';

export interface PlacementRepository {
  getNavigationBars(businessId: number): Promise<PlacementNavigationBar[]>;
}

export class PlacementRepositoryImpl implements PlacementRepository {
  // eslint-disable-next-line no-useless-constructor
  constructor(
    private readonly dataSource: PlacementDataSource = placementDataSource,
  ) {}

  async getNavigationBars(businessId: number) {
    const response = await this.dataSource.getNavigationBars(businessId);
    return parseModelArray(
      placementNavigationBarSchema,
      response,
      'PlacementNavigationBar',
    );
  }
}

export const placementRepository = new PlacementRepositoryImpl();
